import React from 'react';

import {assert} from 'Asserts';
import FileStates from 'FileStates';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import StudyDesignTabState from 'studies/workspace/tabs/StudyDesignTabState';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

async function navigateToStudyDesignTab(studyId: string, studyType: StudyType): Promise<void> {
  const studyFile = await FileStates.get().openFolderItem(studyId, {open: true});
  if (!studyFile) {
    // The user may have aborted opening the file.
    return;
  }
  const existingTab = studyFile.findTab(StudyDesignTabState);
  assert(existingTab != null, 'Expected study to have a StudyDesignTabState', {studyId, studyType});
  existingTab.set({active: true});
}

/**
 * This component should only be rendered if the study has a design tab, which can be checked via
 * looking up the configuration in the corresponding TypedStudyAdapter.
 */
export default function StudyDesignTabButton({
  studyId,
  studyType,
}: {
  studyId: string;
  studyType: StudyType;
}): JSX.Element {
  return (
    <Button
      buttonStyle={ButtonStyle.TERTIARY_BLUE}
      size={ButtonSize.SMALL}
      autoHeight={true}
      fullWidth={false}
      icon="arrow-right"
      text="View design"
      onClick={async () => {
        await navigateToStudyDesignTab(studyId, studyType);
      }}
    />
  );
}
